import { useCallback } from 'react';
import { currencyColumns } from '../cols-definition';
import { useDynamicSearch } from '@/hooks';
import { QUERY_KEYS } from '@/constants';

interface UseSearchTableProps {
  handlePageChange: (page: number) => Promise<void>;
}

const EMPTY_PARAMS = {};

export const useSearchTable = ({ handlePageChange }: UseSearchTableProps) => {
  const getColumns = useCallback(() => {
    return currencyColumns.map(col => ({
      field: col.field,
      type: col.type
    }));
  }, []);

  const { searchState, handleSearchChange, handleSearchPageChange, hasFilterParams, handleRefreshClick, isSearching } =
    useDynamicSearch({
      onSearch: async () => Promise.resolve(),
      params: EMPTY_PARAMS,
      getColumns,
      endpoint: `${QUERY_KEYS.NGOAI_TE}/filter`,
      pageSize: 20
    });

  const onPageChange = useCallback(
    async (page: number) => {
      if (hasFilterParams) {
        await handleSearchPageChange(page);
      } else {
        await handlePageChange(page);
      }
    },
    [hasFilterParams, handleSearchPageChange, handlePageChange]
  );

  return {
    searchState,
    handleSearchChange,
    onPageChange,
    hasFilterParams,
    handleRefreshClick,
    isFiltering: isSearching
  };
};
